import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import ViewBookmark from "../ViewBookmarks";
import { CommonTabCardProp } from "../../../../Types/BookmarkType";
import SearchNotFoundClass from "../../../CommonComponents/SearchNotFound/SearchNotFoundClass";
import { H5 } from "../../../../AbstractElements";

const CommonTabCard:React.FC<CommonTabCardProp> = ({ tabId, title }) => {
  return (
    <TabPane tabId={tabId}>
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <H5 className="mb-0">{title}</H5>
          <ViewBookmark />
        </CardHeader>
        <CardBody>
          <SearchNotFoundClass word="Bookmark"/>
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default CommonTabCard;
